export { default } from './VehiclePage'
